export default __webpack_public_path__ + "static/media/31t.5eb7da51.jpg";